import { CommandBar, ICommandBarItemProps } from "@fluentui/react";
import { useEffect, useState } from "react";
import { IPagination } from "../../Interfaces/base/ITable";
import { _initialPagination } from "../../utils/helpers/helpers";
import Pagination from "../Pagination/pagination";

let _pagination: IPagination = _initialPagination();

export const PaginationFooterB = ({
  total = 0,
  pagination = _pagination,
  valueChangeSize,
}) => {
  const [itemByPage, setItemByPage] = useState(pagination.pageSize);

  useEffect(() => {
    valueChangeSize(itemByPage);
  }, [itemByPage]);

  const footerLeft = () => {
    let start =
      total > 0 ? (pagination.currentPage - 1) * pagination.pageSize + 1 : 0;
    let end = total > 0 ? start + total - 1 : 0;

    const _items: ICommandBarItemProps[] = [
      {
        key: "ItemsByPage",
        text: `Items por pagina ${itemByPage}`,
        split: true,
        disabled: false,
        subMenuProps: {
          items: [
            {
              key: "five",
              text: "5",
              iconProps: { iconName: "WorkItemBarSolid" },
              onClick: () => setItemByPage(5),
            },
            {
              key: "ten",
              text: "10",
              iconProps: { iconName: "WorkItemBarSolid" },
              onClick: () => setItemByPage(10),
            },
            {
              key: "twentyFive",
              text: "25",
              iconProps: { iconName: "WorkItemBarSolid" },
              onClick: () => setItemByPage(25),
            },
            {
              key: "hundred",
              text: "100",
              iconProps: { iconName: "WorkItemBarSolid" },
              onClick: () => setItemByPage(100),
            },
          ],
        },
        className: "ms-fontSize-12",
      },
      {
        key: "Info",
        text: `${start} - ${end} de ${pagination.total}`,
        className: "ms-fontSize-12",
      },
    ];
    return _items;
  };

  const footerRigth = () => {
    const _items: ICommandBarItemProps[] = [
      {
        key: "Pagination",
        onRender: () => (
          <>
            <Pagination
              currentPage={pagination.currentPage}
              totalCount={pagination.total}
              pageSize={itemByPage}
              onPageChange={pagination.onPageChange}
            />
          </>
        ),
      },
    ];
    return _items;
  };
  return (
    <>
      <CommandBar
        className="ms-fontSize-10"
        items={footerLeft()}
        farItems={footerRigth()}
        styles={{ root: { padding: 0 } }}
      />
    </>
  );
};
